// @TODO:
export default function getCountOfParticipants (exam) {
  const groups = exam.shifts ? [...exam.shifts.map(item => item.groups || [])].flat() : []
  const count = groups ? groups.map(group => group.participants).flat().filter(item => item && item.status === 'passed').length : 0
  return count === 0 ? '0' : count
}
